import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import jobsReducer from './slices/jobsSlice';
import adminReducer from './slices/adminSlice';
import apiKeysReducer from './slices/apiKeysSlice';
import analyticsReducer from './slices/analyticsSlice';
import debugReducer from './slices/debugSlice';
import identityReducer from './slices/identitySlice';
import dataSourcesReducer from './slices/dataSourcesSlice';
import schedulerReducer from './slices/schedulerSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    jobs: jobsReducer,
    admin: adminReducer,
    apiKeys: apiKeysReducer,
    analytics: analyticsReducer,
    debug: debugReducer,
    identity: identityReducer,
    dataSources: dataSourcesReducer,
    scheduler: schedulerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
